import React, { useEffect } from "react";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { fetchAllReqsAsync } from "../../redux/reqs/reqs.actions";
import { selectAllReqs } from "../../redux/reqs/reqs.selectors";

import socket from "../../assets/socketConnection";
import ReqCardsList from "../ReqCardsList/ReqCardsList.container";

const AllReqsList = ({ fetchAllReqsAsync, selectAllReqs }) => {
  useEffect(() => {
    // console.log("selectAllReqs", !!selectAllReqs);
    // if (selectAllReqs.length === 0)
    fetchAllReqsAsync(socket);

    // socket.emit("get_loads", {
    //   filter: { id: "BRN-2113112200-4727" },
    // });

    //
    // BRN-2114134540-9137
    // page: 1,

    // socket.on("response_loads", (data) => {
    //   console.log("dataaaa", data);
    //   alert("fds");
    //   // dispatch(fetchAllReqsSuccess(data));
    // });
    // return () => {
    //     cleanup
    // }
  }, []);
  return (
    // <>
    <ReqCardsList reqs={selectAllReqs} />
    // </>
  );
};

const mapStateToProps = createStructuredSelector({
  selectAllReqs: selectAllReqs,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAllReqsAsync: (x, y) => dispatch(fetchAllReqsAsync(x, y)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AllReqsList);
